import { IconButton } from "@mui/material";
import { Carousel } from "react-bootstrap";
import styled from "styled-components";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { styled as muiStyled } from '@mui/material/styles';

export const StyledHeroCardContainer = styled.div`
    width: 100%;
    height: 60vh;
    @media (min-width: 768px) {
        height: 75vh;
    }
`;

export const StyledHeroCard = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    &:hover {
        cursor: pointer;
    }
`;

export const StyledHeroCardImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 0;
    
    /* Hide portrait image on landscape orientation */
    @media (orientation: landscape) {
        &[data-orientation="portrait"] {
            display: none;
        }
    }
    
    /* Hide landscape image on portrait orientation */
    @media (orientation: portrait) {
        &[data-orientation="landscape"] {
            display: none;
        }
    }
`;

export const StyledHeroCardTransition = styled.div`
    margin-top: -250px;
    height: 255px;
    width: 100%;
    background: linear-gradient(to bottom, rgba(30,31,35,0), rgba(30,31,35,1));
    background-size: 100%;
    background-repeat: no-repeat;
`;

export const StyledHeroCardContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 75%;
    font-family: Outfit;
    font-style: normal;
    font-weight: 400;
    line-height: 1.1;
    color: #FFFFFF;
    height: 100%;
    justify-content: center;
    padding-left: 10%;
    margin-top: 64px;
    font-size: 12px;
    position: relative;
    z-index: 1;
    
    @media (min-width: 768px) {
        padding-left: 5%;
        font-size: 22px;
        width: 50%;
    }

`;

export const StyledHeroCardDesc = styled.div`
    margin: 20px 0;
`;

export const StyledHeroCardTitle = styled.div`
    font-size: 22px;
    font-weight: 600;
    
    @media (min-width: 768px) {
        font-size: 32px;
}
`;

export const StyledCoursePlay = styled(IconButton)`
    .MuiSvgIcon-root{
        width: 64px;
        height: 64px;
        color: #FFFFFF;
        @media(min-width: 768px){
            width: 96px;
            height: 96px;
        }
    }
`;

export const StyledCarouselPrevIcon = muiStyled(ArrowBackIosNewIcon)`
        width: 30px;
        height: 45px;
        color: #FFFFFF;
        @media (min-width: 768px){
            width: 60px;
            height: 90px;
        }
`;

export const StyledCarouselNextIcon = muiStyled(ArrowForwardIosIcon)`
        width: 30px;
        height: 45px;
        color: #FFFFFF;
        @media (min-width: 768px){
            width: 60px;
            height: 90px;
        }
`;

export const StyledPlayButtonContainer = styled.div`
    display: flex;
    align-items: center;
    background: none;
    border: none;
    color: #FFFFFF;
`;

export const StyledCarousel = styled(Carousel)`
    /* react-bootstrap's Carousel needs Bootstrap's structural CSS to behave as a
       slideshow. Bootstrap's stylesheet is intentionally not bundled app-wide, so
       the required rules are reproduced here, scoped to this carousel only. Without
       them every slide renders stacked (a vertical scroll) instead of one-at-a-time. */
    position: relative;

    .carousel-inner {
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .carousel-item {
        position: relative;
        display: none;
        float: left;
        width: 100%;
        margin-right: -100%;
        backface-visibility: hidden;
        transition: transform 0.6s ease-in-out;
    }

    .carousel-item.active,
    .carousel-item-next,
    .carousel-item-prev {
        display: block;
    }

    .carousel-item-next:not(.carousel-item-start),
    .active.carousel-item-end {
        transform: translateX(100%);
    }

    .carousel-item-prev:not(.carousel-item-end),
    .active.carousel-item-start {
        transform: translateX(-100%);
    }

    @media (prefers-reduced-motion: reduce) {
        .carousel-item {
            transition: none;
        }
    }

    .carousel-control-prev,
    .carousel-control-next {
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 5%;
        margin-top: 64px;
        padding: 0;
        color: #ffffff;
        background: none;
        border: 0;
        opacity: 0.65;
        transition: opacity 0.15s ease;

        &:hover {
            opacity: 1;
        }
    }
    /* Bootstrap renders the control/label text as visually-hidden spans; without
       Bootstrap's utility CSS they would show as literal "Previous"/"Next" text. */
    .visually-hidden,
    .sr-only {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
    }

    .carousel-control-prev {
        left: 0;
        .carousel-control-prev-icon{
            width: 48px;
            height: 48px;
        }
    }
    .carousel-control-next {
        right: 0;
        .carousel-control-next-icon{
            width: 48px;
            height: 48px;
        }
    }
    .carousel-indicators{
        position: absolute;
        right: 0;
        left: 0;
        bottom: 5%;
        z-index: 2;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding: 0 24px;
        margin: 0;
        list-style: none;
        @media(min-width: 768px){
            bottom: 10%;
        }
        button {
            box-sizing: content-box;
            width: 8px;
            height: 8px;
            background-color: darkgray;
            border-radius: 50%;
            border: none;
            padding: 0;
            margin: 0 7px 8px;
            cursor: pointer;
            @media (min-width: 768px) {
                width: 16px;
                height: 16px;
            }
        }
        .active {
            background-color: #FFFFFF;
        }
    }

`;